// Basic imports
import React from "react";
import Logo from "../assets/Images/eeezo_logo.png";
import SignIn from "../components/SignIn/SignIn";

const Home = () => {
  return (
    <div className="radial-gradient-bg">
      <div className="SignInLogo ml-4 absolute py-2">
        <img src={Logo} className="w-auto h-10 object-contain" />
      </div>
      <div className="signup-page">
        <SignIn />
      </div>
    </div>
  );
};

export default Home;
